module.exports = __webpack_public_path__ + "img/ski_place2.388a53d9.png";